import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Dostawy zewnętrzne',
  fields: {
    pickup: 'Odbiór',
    dropoff: 'Dostawa',
    status: 'Status',
    estimated_time: 'Szacowany czas',
    actual_time: 'Rzeczywisty czas',
    actions: 'Akcje',
    time: 'Czas',
    pickup_estimate: 'Szacowany czas odbioru',
    dropoff_estimate: 'Szacowany czas dostawy',
  },
  labels: {
    pickup: 'Odbiór',
    dropoff: 'Dostawa',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Oczekiwanie na kierowcę',
    [DeliveryStatus.RunnerAssigned]: 'Kierowca przypisany',
    [DeliveryStatus.OnRoutePickup]: 'W drodze do odbioru',
    [DeliveryStatus.ArrivedPickup]: 'Dotarł do punktu odbioru',
    [DeliveryStatus.PickedUp]: 'Odebrano',
    [DeliveryStatus.OnRouteDropoff]: 'W drodze do dostawy',
    [DeliveryStatus.ArrivedDropoff]: 'Dotarł do punktu dostawy',
    [DeliveryStatus.Completed]: 'Zrealizowano',
    [DeliveryStatus.Cancelled]: 'Anulowano',
  },
  buttons: {
    actions: 'Akcje',
    open_tracking_url: 'Śledź dostawę',
    show_order_details: 'Pokaż szczegóły zamówienia',
    call_restaurant: 'Zadzwoń do restauracji',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
